import React from "react";
import styles from "./topics.module.scss";

export const EventTopics = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.heading_container}>
          <h1 className={styles.heading}>
            What Topics we <br /> will Discuss
          </h1>
          <div className={styles.bottom_border}></div>
        </div>

        <div className={styles.topics_container}>
          <div className={styles.card_container}>
            <div className={styles.card_body}>
              <h4>Education Theory</h4>
              <p>
                Exclusively for Principals, these sessions look at the chall
              </p>
            </div>
          </div>
          <div className={styles.card_container}>
            <div className={styles.card_body}>
              <h4>Education Policy</h4>
              <p>
                Member of the multidisciplinary team of the “Maison des Sciences
              </p>
            </div>
          </div>
          <div className={styles.card_container}>
            <div className={styles.card_body}>
              <h4>Child Education</h4>
              <p>
                Institutions face the qualities and required to make a good
                leader
              </p>
            </div>
          </div>
          <div className={styles.card_container}>
            <div className={styles.card_body}>
              <h4>Future Learning</h4>
              <p>
                Member of the multidisciplinary team of the “Maison des Sciences
              </p>
            </div>
          </div>
          <div className={styles.card_container}>
            <div className={styles.card_body}>
              <h4>Leadership Stream</h4>
              <p>
                Learn from the very best, see real stori from expert educators
              </p>
            </div>
          </div>
          <div className={styles.card_container}>
            <div className={styles.card_body}>
              <h4>Others</h4>
              <p>
                Find out about the latest innovations in products and services
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventTopics;
